import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import API from '../utils/api';

const API_BASE = process.env.REACT_APP_API_URL?.replace('/api', '') || '';

export default function Activities() {
  const { t } = useTranslation();
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.get('/activities').then(r => { setActivities(r.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  const defaultActivities = [
    { _id: '1', title: t('activities.default1Title'), titleHindi: 'दैनिक चारा-पानी', description: t('activities.default1Desc'), icon: '🌾' },
    { _id: '2', title: t('activities.default2Title'), titleHindi: 'पशु स्वास्थ्य शिविर', description: t('activities.default2Desc'), icon: '🏥' },
    { _id: '3', title: t('activities.default3Title'), titleHindi: 'गोपाष्टमी', description: t('activities.default3Desc'), icon: '🎉' },
    { _id: '4', title: t('activities.default4Title'), titleHindi: 'गो-रक्षा अभियान', description: t('activities.default4Desc'), icon: '🚑' },
    { _id: '5', title: t('activities.default5Title'), titleHindi: 'जैविक खेती सेवा', description: t('activities.default5Desc'), icon: '🌱' },
    { _id: '6', title: t('activities.default6Title'), titleHindi: 'गो-दुग्ध वितरण', description: t('activities.default6Desc'), icon: '🥛' },
  ];

  const displayList = activities.length > 0 ? activities : defaultActivities;

  return (
    <div>
      <div className="page-header">
        <h1>{t('activities.pageTitle')}</h1>
        <p>{t('activities.pageSubtitle')}</p>
      </div>

      <section className="section">
        <div className="container">
          {loading ? (
            <div className="loader"><div className="spinner" /></div>
          ) : (
            <div className="grid-2">
              {displayList.map((a, i) => (
                <div key={a._id || i} style={{ background: '#fff', borderRadius: 12, padding: 28, boxShadow: '0 2px 16px rgba(0,0,0,0.08)', display: 'flex', gap: 20, border: '1px solid #f0ebe2' }}>
                  {a.image
                    ? <img src={`${API_BASE}${a.image}`} alt={a.title} style={{ width: 120, height: 100, objectFit: 'cover', borderRadius: 10, flexShrink: 0 }} />
                    : <div style={{ width: 80, height: 80, flexShrink: 0, background: '#FFF3EB', borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '2.5rem' }}>
                        {a.icon || '🐂'}
                      </div>
                  }
                  <div>
                    <h3 style={{ fontWeight: 700, marginBottom: 4, color: '#1a1a1a' }}>{a.title}</h3>
                    {a.titleHindi && <div style={{ fontFamily: 'Noto Serif Devanagari, serif', color: 'var(--saffron)', fontSize: '0.95rem', marginBottom: 8 }}>{a.titleHindi}</div>}
                    <p style={{ color: '#666', fontSize: '0.9rem', lineHeight: 1.7 }}>{a.description || a.descriptionHindi}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
